import gql from 'graphql-tag';

export const DELETE_TABLE_FILTER = gql`
  mutation DeleteTableFilter($tableFilterId: ID!) {
    tableFilter {
      result: deleteFilter(tableFilterId: $tableFilterId) {
        success
        error
      }
    }
  }
`;
